import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { OrganizationsService } from '../../../api/services/organizations.service';
import { OrganizationActionTypes } from '../actions/organization.actions';

@Injectable()
export class OrganizationEffects {
  private readonly actions$ = inject(Actions);
  private readonly organizationsService = inject(OrganizationsService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  readAll$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(OrganizationActionTypes.READ_ALL),
      switchMap(() =>
        this.organizationsService.listOrganizations().pipe(
          map((response) => ({
            type: OrganizationActionTypes.READ_ALL_SUCCESS,
            organizations: response,
          })),
          catchError(() => {
            return of({ type: OrganizationActionTypes.READ_ALL_FAILED });
          })
        )
      )
    );
  });
}
